import { gql } from '@apollo/client';

export const documentFields = gql`
  fragment DocumentFields on Document {
    url
    filename
    byteSize
    generated
    createdAt
    updatedAt
  }
`;

export const archiveDocumentMutation = gql`
  mutation ArchiveDocument($input: ArchiveDocumentInput!) {
    archiveDocument(input: $input) {
      document {
        id
        ...DocumentFields
      }
      errors {
        message
      }
    }
  }
  ${documentFields}
`;
